import { render, staticRenderFns } from "./editDisplayName.vue?vue&type=template&id=2def0198&scoped=true&"
import script from "./editDisplayName.vue?vue&type=script&lang=js&"
export * from "./editDisplayName.vue?vue&type=script&lang=js&"
import style0 from "./editDisplayName.vue?vue&type=style&index=0&id=2def0198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def0198",
  null
  
)

export default component.exports